import axios from 'axios';
import { charsheetAPI } from '../globals.js';

const updateCampaign = async (campaignName, fields) => {
    const API_URL = `${charsheetAPI}?TableName=charsheet-campaigns&CampaignName=${campaignName}`;
    try {
        const res = await axios({
            method: 'PATCH',
            url: API_URL,
            headers: { 'content-type': 'text/plain' },
            withCredentials: true,
            data: { ...fields }
        });
        return res.data;
    } catch (error) {
        console.error('Error updating campaign:', error);
        return null;
    }
};

export default updateCampaign;
